import { Routes } from '@angular/router';

export const MARKETING_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./marketing-layout.component').then((m) => m.MarketingLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./home-page/home-page.component').then((m) => m.HomePageComponent),
        data: { title: 'Home' },
      },
      {
        path: 'home1',
        loadComponent: () =>
          import('./home1-page/home1-page.component').then((m) => m.Home1PageComponent),
        data: { title: 'Home (Archive)' },
      },
      {
        path: 'product',
        loadComponent: () =>
          import('./product-page/product-page.component').then((m) => m.ProductPageComponent),
        data: { title: 'Product' },
      },
      {
        path: 'review-intelligence',
        loadComponent: () =>
          import('./review-intelligence-page/review-intelligence-page.component').then(
            (m) => m.ReviewIntelligencePageComponent,
          ),
        data: { title: 'Review Intelligence' },
      },
      {
        path: 'pricing',
        loadComponent: () =>
          import('./pricing/pricing-page.component').then((m) => m.PricingPageComponent),
        data: { title: 'Pricing' },
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./about-page/about-page.component').then((m) => m.AboutPageComponent),
        data: { title: 'About' },
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./contact-page/contact-page.component').then((m) => m.ContactPageComponent),
        data: { title: 'Contact' },
      },
      {
        path: 'blog',
        loadComponent: () =>
          import('./blog/marketing-blog-list-page.component').then(
            (m) => m.MarketingBlogListPageComponent,
          ),
        data: { title: 'Blog' },
      },
      {
        path: 'blog/category/:slug',
        loadComponent: () =>
          import('./blog/marketing-blog-category-page.component').then(
            (m) => m.MarketingBlogCategoryPageComponent,
          ),
        data: { title: 'Blog' },
      },
      {
        path: 'blog/preview',
        loadComponent: () =>
          import('./blog/marketing-blog-preview-page.component').then(
            (m) => m.MarketingBlogPreviewPageComponent,
          ),
        data: { title: 'Preview' },
      },
      {
        path: 'blog/:slug',
        loadComponent: () =>
          import('./blog/marketing-blog-post-page.component').then(
            (m) => m.MarketingBlogPostPageComponent,
          ),
        data: { title: 'Blog' },
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./policy-page/policy-page.component').then((m) => m.PolicyPageComponent),
        data: { title: 'Privacy Policy', policySlug: 'privacy' },
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./policy-page/policy-page.component').then((m) => m.PolicyPageComponent),
        data: { title: 'Terms and Conditions', policySlug: 'terms' },
      },
      {
        path: 'refund-policy',
        loadComponent: () =>
          import('./legal-notice-page/legal-notice-page.component').then((m) => m.LegalNoticePageComponent),
        data: { title: 'Refund Policy' },
      },
      {
        path: 'pricing-policy',
        loadComponent: () =>
          import('./policy-page/policy-page.component').then((m) => m.PolicyPageComponent),
        data: { title: 'Pricing Policy', policySlug: 'pricing' },
      },
    ],
  },
];
